import { CheckCircle2, RotateCcw, Send } from "lucide-react";
import PropTypes from "prop-types";
import { REVERTIBLE_STATUSES } from "../misc/constants";

/**
 * Ops' side of the debit note flow, for the preview footer: issue a draft,
 * recall a note the brand hasn't approved yet, confirm funds on an approved one.
 */
const DebitNoteActions = ({ note, onIssue, onRevert, onMarkAsReceived }) => (
    <>
        {note.status === "draft" && (
            <button
                type="button"
                onClick={() => onIssue(note._id)}
                className="inline-flex items-center gap-1.5 rounded-lg bg-navy px-3 py-1.5 text-xs font-semibold text-white hover:bg-navy/90">
                <Send className="h-3.5 w-3.5" />
                Issue to brand
            </button>
        )}
        {REVERTIBLE_STATUSES.includes(note.status) && (
            <button
                type="button"
                onClick={() => onRevert(note)}
                className="inline-flex items-center gap-1.5 rounded-lg border border-gray-300 px-3 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-50">
                <RotateCcw className="h-3.5 w-3.5" />
                Revert
            </button>
        )}
        {note.status === "approved" && (
            <button
                type="button"
                onClick={() => onMarkAsReceived(note._id)}
                className="inline-flex items-center gap-1.5 rounded-lg bg-navy px-3 py-1.5 text-xs font-semibold text-white hover:bg-navy/90">
                <CheckCircle2 className="h-3.5 w-3.5" />
                Mark as received
            </button>
        )}
    </>
);

DebitNoteActions.propTypes = {
    note            : PropTypes.object.isRequired,
    onIssue         : PropTypes.func.isRequired,
    onRevert        : PropTypes.func.isRequired,
    onMarkAsReceived: PropTypes.func.isRequired
};

export default DebitNoteActions;
